<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>出海案例</h1>
        <div class="sub">真实落地案例 · 共 {{ cases.length }} 个</div>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div class="card-grid" v-if="pagedCases.length">
          <div
            v-for="item in pagedCases"
            :key="item.id"
            class="card case-card"
            @click="$router.push('/case/' + item.id)"
          >
            <div class="case-header" :style="{ background: item.headerBg || '#2444cb' }">
              <span class="case-tag">{{ item.tagText }}</span>
              <span class="case-title">{{ item.title }}</span>
            </div>
            <div class="card-body">
              <div class="card-desc">{{ item.content }}</div>
              <div class="card-detail-btn case-btn" :style="{ background: item.headerBg || '#2444cb' }">查看详情</div>
            </div>
          </div>
        </div>

        <div class="empty-block" v-else-if="!loading">暂无案例</div>
        <div class="empty-block" v-else>加载中…</div>

        <!-- 分页 -->
        <div class="pager" v-if="caseTotalPages > 1">
          <button class="pg-btn" :disabled="casePage <= 1" @click="goCasePage(casePage - 1)">‹ 上一页</button>
          <button
            v-for="p in casePages"
            :key="p"
            class="pg-num"
            :class="{ active: p === casePage }"
            @click="goCasePage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="casePage >= caseTotalPages" @click="goCasePage(casePage + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchCases } from '../api/home'

export default {
  name: 'CasesList',
  data () {
    return {
      cases: [],
      casePage: 1,
      casePageSize: 8,
      loading: true
    }
  },
  computed: {
    caseTotalPages () {
      return Math.max(1, Math.ceil(this.cases.length / this.casePageSize))
    },
    pagedCases () {
      const start = (this.casePage - 1) * this.casePageSize
      return this.cases.slice(start, start + this.casePageSize)
    },
    casePages () {
      const tp = this.caseTotalPages
      const cur = this.casePage
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.cases = await fetchCases()
      } catch (e) {
        this.cases = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    goCasePage (p) {
      if (p < 1 || p > this.caseTotalPages || p === this.casePage) return
      this.casePage = p
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-main);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary);
  color: var(--primary);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub);
  padding: 0 4px;
}
.empty-block {
  text-align: center;
  color: var(--text-sub);
  padding: 40px 0;
}
</style>
